<div *ngIf="!showTenantSelection" class="w-100">
  <div class="w-100 t-ar">
    <a (click)="openConfig()">{{ 'dashboard.show-hide-sections' | translate }}</a>
  </div>
  <div
    class="flex column gap-3rem-lt-md gap-6rem-gt-sm mct-flex mct-col"
    *ngIf="config.MoveMyTasksToTop || config.MoveMySalesOpportunitiesToTop"
    [hidden]="(!config.ShowMyTasks || hideTasks) && (!config.ShowMySalesOpportunities || hideSalesOpps)"
    style="margin-bottom: 6rem"
  >
    <wl-dashboard-neo-tasks *ngIf="config.MoveMyTasksToTop" [hidden]="!config.ShowMyTasks || hideTasks"></wl-dashboard-neo-tasks>
    <wl-dashboard-neo-sales-opportunities
      *ngIf="config.MoveMySalesOpportunitiesToTop"
      [hidden]="!config.ShowMySalesOpportunities || hideSalesOpps"
    ></wl-dashboard-neo-sales-opportunities>
  </div>
  <div
    class="grid cols-1fr-2fr-collapse gap-6rem-2rem-gt-sm gap-3rem-lt-md align-stretch"
    style="margin-bottom: 1rem"
    [hidden]="!config.ShowUpcomingEvents && !config.ShowMembershipActitiyTotals"
  >
    <wl-dashboard-neo-events [hidden]="!config.ShowUpcomingEvents || hideEvents"></wl-dashboard-neo-events>
    <wl-dashboard-neo-membership-activity
      [hidden]="!config.ShowMembershipActitiyTotals || hideMembership"
      [hideTasks]="hideTasks"
      [hideRetention]="hideRetention"
      [hideSalesOpps]="hideSalesOpps"
      [(startDate)]="config.StartDate"
      [(endDate)]="config.EndDate"
    ></wl-dashboard-neo-membership-activity>
  </div>
  <div class="w-100" style="margin-bottom: 6rem" [hidden]="!config.ShowUpcomingEvents && !config.ShowMembershipActitiyTotals">
    <wl-dashboard-neo-membership-reports
      [hidden]="!config.ShowMembershipActitiyTotals || hideMembership"
    ></wl-dashboard-neo-membership-reports>
  </div>
  <div
    class="grid cols-1fr-2fr-collapse gap-6rem-2rem-gt-sm gap-3rem-lt-md"
    style="margin-bottom: 1rem"
    [hidden]="!config.ShowMyReports && !config.ShowFinance"
  >
    <wl-dashboard-neo-reports [hidden]="!config.ShowMyReports || hideMyReports"></wl-dashboard-neo-reports>
    <wl-dashboard-neo-revenue [hidden]="!config.ShowFinance || hideRevenueModule"></wl-dashboard-neo-revenue>
  </div>
  <div class="w-100" style="margin-bottom: 6rem" [hidden]="(!config.ShowMyReports && !config.ShowFinance) || hideRevenueReports">
    <wl-dashboard-neo-financial-reports [hidden]="!config.ShowFinance"></wl-dashboard-neo-financial-reports>
  </div>
  <div
    class="flex column gap-3rem-lt-md gap-6rem-gt-sm"
    [hidden]="!config.ShowMyTasks && !config.ShowMySalesOpportunities && config.MoveMyTasksToTop && config.MoveMySalesOpportunitiesToTop"
  >
    <div>
      <wl-dashboard-neo-tasks *ngIf="!config.MoveMyTasksToTop" [hidden]="!config.ShowMyTasks || hideTasks"></wl-dashboard-neo-tasks>
    </div>
    <div>
      <wl-dashboard-neo-sales-opportunities
        *ngIf="!config.MoveMySalesOpportunitiesToTop"
        [hidden]="!config.ShowMySalesOpportunities || hideSalesOpps"
      ></wl-dashboard-neo-sales-opportunities>
    </div>
  </div>
</div>
<p-dialog modal="true" styleClass="atlas-dialog-s" position="middle" [closable]="false" [(visible)]="showConfig">
  <ng-template pTemplate="header">
    <h4>
      {{ 'dashboard.config.config-header' | translate | titlecase }}
    </h4>
  </ng-template>
  <wl-dashboard-neo-config [(config)]="config"></wl-dashboard-neo-config>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" [disabled]="isSaving" (click)="cancelConfig()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="isSaving" (click)="saveConfig()">
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
